module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<svg width="<%= width %>" height="<%= height %>" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n\t <path fill-rule="evenodd" clip-rule="evenodd" d="M0.925736 0.175828C1.16005 -0.0584871 1.53995 -0.0584871 1.77426 0.175828L3.85 2.25156L5.92574 0.175828C6.16005 -0.0584871 6.53995 -0.0584871 6.77426 0.175828C7.00858 0.410142 7.00858 0.790041 6.77426 1.02436L4.69853 3.10009L6.77426 5.17583C7.00858 5.41014 7.00858 5.79004 6.77426 6.02436C6.53995 6.25867 6.16005 6.25867 5.92574 6.02436L3.85 3.94862L1.77426 6.02436C1.53995 6.25867 1.16005 6.25867 0.925736 6.02436C0.691421 5.79004 0.691421 5.41014 0.925736 5.17583L3.00147 3.10009L0.925736 1.02436C0.691421 0.790041 0.691421 0.410142 0.925736 0.175828Z" fill="currentColor"/>\n</svg>\n', __filename = "videojs-chat/templates/delete.svg.html";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        with (locals || {}) {
            __append('<svg width="');
            __append(escapeFn(width));
            __append('" height="');
            __append(escapeFn(height));
            __append('" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n\t <path fill-rule="evenodd" clip-rule="evenodd" d="M0.925736 0.175828C1.16005 -0.0584871 1.53995 -0.0584871 1.77426 0.175828L3.85 2.25156L5.92574 0.175828C6.16005 -0.0584871 6.53995 -0.0584871 6.77426 0.175828C7.00858 0.410142 7.00858 0.790041 6.77426 1.02436L4.69853 3.10009L6.77426 5.17583C7.00858 5.41014 7.00858 5.79004 6.77426 6.02436C6.53995 6.25867 6.16005 6.25867 5.92574 6.02436L3.85 3.94862L1.77426 6.02436C1.53995 6.25867 1.16005 6.25867 0.925736 6.02436C0.691421 5.79004 0.691421 5.41014 0.925736 5.17583L3.00147 3.10009L0.925736 1.02436C0.691421 0.790041 0.691421 0.410142 0.925736 0.175828Z" fill="currentColor"/>\n</svg>\n');
            __line = 4;
        }
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}